<app-page-header title="Effectiveness" description="Analyse promotion performance over a reporting period."></app-page-header>
<div class="effectiveness-container">
  <!-- Filter Bar -->
  <div class="filter-bar">
    <div class="filter-item">
      <label class="filter-label">Reporting Period</label>
      <dx-date-range-box
        [startDate]="startDate"
        [endDate]="endDate"
        startDateLabel="Start Date"
        endDateLabel="End Date"
        displayFormat="d MMM yyyy"
        [showClearButton]="false"
        (onValueChanged)="onRangeChanged($event)">
      </dx-date-range-box>
    </div>

    <div class="filter-item">
      <label class="filter-label">Buying Group</label>
      <dx-select-box
        [dataSource]="buyingGroups"
        displayExpr="buying_group_name"
        valueExpr="id"
        [value]="selectedBuyingGroup"
        placeholder="All Buying Groups"
        [showClearButton]="true"
        (onValueChanged)="onBuyingGroupChanged($event)">
      </dx-select-box>
    </div>

    <div class="filter-item">
      <label class="filter-label">Promotion Type</label>
      <dx-select-box
        [dataSource]="promotionTypes"
        displayExpr="name"
        valueExpr="name"
        [value]="selectedPromotionType"
        placeholder="All Promotion Types"
        [showClearButton]="true"
        (onValueChanged)="onPromotionTypeChanged($event)">
      </dx-select-box>
    </div>
  </div>

  <!-- Content -->
  <div id="data-area" class="tab-content">
    @if (showBreakdown && breakdownContext) {
      <app-product-breakdown
        [products]="breakdownData?.products ?? null"
        [loadFailed]="breakdownLoadFailed"
        [promotionName]="breakdownContext.promotionName"
        [buyingGroup]="breakdownContext.buyingGroup"
        [type]="breakdownContext.type"
        [totalVolume]="breakdownContext.totalVolume"
        (backRequested)="onBreakdownBack()">
      </app-product-breakdown>
    } @else {
      <app-monthly-summary
        [data]="summaryData"
        [periodStart]="formatDate(startDate)"
        [periodEnd]="formatDate(endDate)"
        [selectedBuyingGroupName]="selectedBuyingGroupName"
        [selectedPromotionType]="selectedPromotionType"
        (breakdownRequested)="onBreakdownRequested($event)">
      </app-monthly-summary>
    }
  </div>

  <!-- Loading Panel -->
  <dx-load-panel
    [visible]="isLoading"
    [position]="{ of: '#data-area' }"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [shadingColor]="'rgba(0,0,0,0.1)'">
  </dx-load-panel>
</div>
